import styled from 'styled-components';
import { ModalIncompletePxStyled } from '../ModalIncompletePxStyled';
import { rem } from 'polished';

export const ModalIncompletePxStyledAP = styled(ModalIncompletePxStyled)`
    
`;
